import { userConstants, documentConstants } from "actions/types";
import type { UserDocumentsState } from "types/state";

interface UserDocumentsAction {
  type: string;
  data?: unknown;
}

type DocumentBucket = "prpStatements" | "iraStatements" | "confirmations";

interface BucketedDocuments {
  bucket: DocumentBucket;
  docs: UserDocumentsState["statements"];
}

interface BucketedDocumentGroups {
  buckets: Partial<Record<DocumentBucket, UserDocumentsState["statements"]>>;
}

const initialState: UserDocumentsState = {
  documents: [],
  statements: [],
  prpStatements: [],
  iraStatements: [],
  confirmations: [],
};

export function userDocuments(
  state: UserDocumentsState = initialState,
  action: UserDocumentsAction
): UserDocumentsState {
  switch (action.type) {
    case userConstants.USER_UPLOADED_DOCUMENT_SUCCESS:
      return {
        ...state,
        documents: [
          action.data as UserDocumentsState["documents"][number],
          ...state.documents,
        ],
      };

    case documentConstants.GET_DOCUMENTS_SUCCESS:
      // Three payload shapes on the same action:
      //  - plain array         -> legacy unfiltered fetch (statements)
      //  - { buckets }         -> one fetch feeding several tabs (APEX split)
      //  - { bucket, docs }    -> single-tab bucketed fetch (e.g. PRP/CRB)
      if (Array.isArray(action.data)) {
        return {
          ...state,
          statements: action.data as UserDocumentsState["statements"],
        };
      }
      if ((action.data as BucketedDocumentGroups).buckets) {
        return {
          ...state,
          ...(action.data as BucketedDocumentGroups).buckets,
        };
      }
      {
        const { bucket, docs } = action.data as BucketedDocuments;
        return {
          ...state,
          [bucket]: docs,
        };
      }

    case userConstants.CLEAR_USER_UPLOADED_DOCUMENT_SUCCESS:
      return {
        ...state,
        documents: [],
      };

    default:
      return state;
  }
}
